import axios from 'axios';
import { defineStore } from 'pinia';
import type { IHttpRequestOptions } from '~/types/transport/http';
import type { IRequestOptions } from '~/types/transport/requestOptions';

const responses: any = {};

export const http = defineStore('transportHttp', {
  state: () => ({}),
  actions: {
    async get<T = any>(requestOptions: IRequestOptions): Promise<T | null> {
      try {
        const host = requestOptions.host || window?.location?.host || '7bitcasino9.com';
        const url = `https://${host}${requestOptions.url || ''}`;
        const method = 'GET';
        const requestId = `${method}@${url}`;
        if (!responses[requestId] || requestOptions.force) {
          responses[requestId] = await axios.get(url, {
            withCredentials: !!requestOptions.withCredentials,
            timeout: 60000,
          });
        }

        return responses[requestId].data || null;
      } catch (e: any) {
        console.error(e);
        return null;
      }
    },
    async post(_ctx: any, requestOptions: IHttpRequestOptions): Promise<any> {
      try {
        const host = requestOptions.host || window?.location?.host || '7bitcasino9.com';
        const url = `https://${host}${requestOptions.url || ''}`;
        const method = 'POST';
        const requestId = `${method}@${url}`;
        if (!responses[requestId] || requestOptions.force) {
          responses[requestId] = await axios.post(
            url,
            { ...requestOptions.payload },
            { withCredentials: !!requestOptions.withCredentials }
          );
        }
        return responses[requestId].data || null;
      } catch (e: any) {
        return null;
      }
    },
  },
});
